import { EventBus } from '../../../../core/shared/helpers/EventHelper';
import ItemComponent from '../../../../core/infraestructure/ItemComponent';

import SimulatorOfficialDetailViewModel from '../../../../core/features/simulator/viewmodels/SimulatorOfficialDetailViewModel';

export default {
    extends: ItemComponent,
    data() {
        return {
            viewModel: null,
            currentTimer: null,
            timerLabel: null,
            sectionSelected: null,
            sectionIndexSelected: null,
            simulator: null,
            isFinished: false,
            // Permite volver a la pantalla de resultados desde el detalle sin
            // tener que terminar el examen en esa misma sesión.
            isViewingResults: false,
            isLoading: true,
            isTimerLoading: false,
            sessionInfo: null
        };
    },
    mounted() {
        // this.$root.$on('onSubmitedSimulator', this.onSubmitSimulator)
        EventBus.$on('onFinishSection', this.onFinishSection);
        EventBus.$on('session-info', this.onShowSessionInfo);
    },
    beforeDestroy() {
        // this.$root.$off('onSubmitedSimulator', this.onSubmitSimulator);
        EventBus.$off('onFinishSection', this.onFinishSection);
        EventBus.$off('session-info', this.onShowSessionInfo);
    },
    created() {
        this.viewModel = new SimulatorOfficialDetailViewModel(this);
        this.onActive();
    },
    watch: {
        // El nivel de navegación se refleja en la URL (?seccion=N) para que el
        // botón "atrás" del navegador retroceda un nivel en la jerarquía
        // (sección → detalle del simulador) en lugar de abandonar el simulador.
        '$route.query.seccion'() {
            this.onSyncSectionFromRoute();
        },
    },
    computed: {
        // La pantalla de resultados se muestra al terminar el examen en esta
        // sesión o cuando el estudiante la abre explícitamente desde el detalle.
        showResultView() {
            return this.isFinished || this.isViewingResults;
        },
        // Ya existe un resultado consultable: el examen se cerró en otra sesión
        // (isDone) o el estudiante ya respondió todas las preguntas.
        canViewResults() {
            if (!this.simulator) return false;
            return !!(this.simulator.isDone || this.simulator.isCompleted);
        },
        // Avance del estudiante, informado por el servidor.
        answeredQuantity() {
            return (this.simulator && this.simulator.answeredQuantity) || 0;
        },
        totalQuestions() {
            return (this.simulator && this.simulator.totalQuestions) || 0;
        },
    },
    methods: {
        onActive() {
            this.viewModel.onBindFormView(this.$route.params.id)
            this.viewModel.findProfile()
        },
        onBindFormViewResponse(response) {
            setTimeout(() => {
                this.simulator = response.data;
                // Si la URL ya traía una sección (recarga o enlace directo),
                // se abre al terminar de cargar el simulador.
                this.onSyncSectionFromRoute();
            }, 400);

            setTimeout(() => {
                this.isLoading = false
            }, 400);
        },
        onSelectSection(section, index) {
            if (this.viewModel.isSectionSelectable(this.simulator.isTimer, this.currentTimer)) {
                this.isLoading = true
                this.onOpenSection(section, index);

                setTimeout(() => {
                    this.isLoading = false
                }, 450);
            } else {
                this.$notify({
                    title: 'Advertencia',
                    message: 'Debe iniciar el simulador para poder seleccionar una sección',
                    type: 'warning'
                });
            }
        },
        onSubmitSimulator(data) {

        },
        onStartTimer() {
            this.isTimerLoading = true

            setTimeout(() => {
                this.currentTimer = this.viewModel.initTimer({
                    startValues: { minutes: this.viewModel.getTime(this.simulator) },
                    onStart: this.onTimerStart,
                    onUpdate: this.onTimerUpdate,
                    onFinished: this.onTimerFinished
                });
                this.isTimerLoading = false
            }, 600);
        },
        onTimerStart(data) {
            this.timerLabel = data
        },
        onTimerUpdate(data) {
            this.timerLabel = data
        },
        onTimerFinished() {
            this.timerLabel = null
            this.isFinished = true
            this.onCloseSection()
        },
        onFinishSection(data) {
            this.isLoading = true
            setTimeout(() => {
                const index = this.sectionIndexSelected;
                if (index !== null && this.simulator && this.simulator.simulatorSections[index]) {
                    this.simulator.simulatorSections[index].status = data
                }
                this.onCloseSection()
            }, 400);

            setTimeout(() => {
                this.isLoading = false
            }, 450);
        },
        onShowSessionInfo(data) {
            console.log(data)
            this.sessionInfo = data
        },
        onFindProfileResponse(response) {
            if (response && response.isAuthenticated && response.profile) {
                this.sessionInfo = response.profile;
            }
        },
        onFinishSimulator() {
            this.$confirm(`Revisa tus respuestas, puede que falte alguna. Una vez que veas los resultados, no podrás comenzar nuevamente. ¿Deseas continuar?`, 'Alerta', {
                confirmButtonText: 'Aceptar',
                cancelButtonText: 'No',
                type: 'warning',
                closeOnPressEscape: false,
                closeOnClickModal: false,
                confirmButtonClass: 'btn-primary',
                cancelButtonClass: 'btn-cancel',
                showCancelButton: true,
            }).then(() => {
                if (this.currentTimer) {
                    this.currentTimer.stop();
                }
                this.timerLabel = null
                this.isFinished = true
                this.onCloseSection()
            }).catch((error) => {

            });

        },
        // El estudiante pide consultar el resultado de un examen ya finalizado:
        // se abre la pantalla de resultados sin volver a finalizar el examen.
        onViewResults() {
            this.isViewingResults = true;
        },
        // --- Navegación jerárquica: sección → detalle del simulador → lista ---
        // El nivel de sección se guarda en la URL (?seccion=N) para que el
        // historial del navegador y la barra de retorno se comporten igual.
        getSectionIndexFromRoute() {
            const query = this.$route.query || {};
            const raw = query.seccion;
            if (raw === undefined || raw === null || raw === '') return null;
            const index = parseInt(raw, 10);
            return isNaN(index) ? null : index;
        },
        buildRouteQuery(sectionIndex) {
            const query = { ...(this.$route.query || {}) };
            delete query.seccion;
            if (sectionIndex !== null && sectionIndex !== undefined) {
                query.seccion = String(sectionIndex);
            }
            return query;
        },
        onSyncSectionFromRoute() {
            const index = this.getSectionIndexFromRoute();
            if (index === null) {
                // Sin sección en la URL: el detalle vuelve a mostrar el resumen.
                if (this.sectionSelected) {
                    this.sectionSelected = null;
                    this.sectionIndexSelected = null;
                }
                return;
            }
            if (this.sectionIndexSelected === index) return;
            if (!this.simulator || !this.simulator.simulatorSections) return;
            // Un examen ya cerrado no se reabre: el resultado y el detalle por
            // pregunta se consultan desde la pantalla de resultados.
            if (this.simulator.isDone) {
                this.onReplaceRouteQuery(null);
                return;
            }
            const section = this.simulator.simulatorSections[index];
            if (!section) return;
            if (!this.viewModel.isSectionSelectable(this.simulator.isTimer, this.currentTimer)) {
                // La sección aún no puede abrirse (cronómetro sin iniciar):
                // se limpia la URL para no dejar un nivel inconsistente.
                this.onReplaceRouteQuery(null);
                return;
            }
            this.sectionIndexSelected = index;
            this.sectionSelected = section;
        },
        onOpenSection(section, index) {
            this.sectionIndexSelected = index;
            this.sectionSelected = section;
            // La sección queda registrada en el historial: "atrás" regresa al
            // detalle del simulador en vez de salir a la raíz.
            this.$router.push({
                path: this.$route.path,
                query: this.buildRouteQuery(index)
            });
        },
        onCloseSection() {
            this.sectionSelected = null;
            this.sectionIndexSelected = null;
            // `replace` evita dejar una entrada de historial que reabra la sección.
            this.onReplaceRouteQuery(null);
        },
        onReplaceRouteQuery(sectionIndex) {
            if (this.getSectionIndexFromRoute() === null && (sectionIndex === null || sectionIndex === undefined)) {
                return;
            }
            this.$router.replace({
                path: this.$route.path,
                query: this.buildRouteQuery(sectionIndex)
            });
        },
        onBack() {
            // Un nivel arriba: si hay una sección abierta se cierra y se
            // permanece en el detalle del simulador.
            if (this.sectionSelected) {
                this.onCloseSection();
                return;
            }
            this.$router.push('/estudiante/simuladores');
        },
        isSectionFinished(section) {
            return section.status && section.status.isFinished
        },
        allSectionFinished() {
            const sections = this.simulator && this.simulator.simulatorSections ? this.simulator.simulatorSections : [];
            return sections.every(section => section.status && section.status.isFinished);
        }
    },
};